<template>
  <section style="height: 100%">
    <div class="container">
      <!-- <el-aside style="padding-right: 20px;border-right:1px solid #e9eaf2;width: 150px;">
        <h1>账号状态</h1>
        <el-tree
          style="margin-top: 10px;margin-bottom:10px;"
          :data="status"
          node-key="id"
          icon-class="el-icon-s-flag"
          default-expand-all
          :expand-on-click-node="false"
          :highlight-current="true"
          :current-node-key="treeCurrentNode"
        >
          <span
            class="custom-tree-node"
            slot-scope="{ node, data }"
            @click="showTreeWorker(data.id, data.pid)"
          >
            <span>
              {{ data.label }}
            </span>
          </span>
        </el-tree>
      </el-aside> -->
      <el-main style="width: 100%;box-sizing: border-box;padding-left:20px;">
        <div
          class="worker-tooltips"
          style="display:flex;flex-wrap:wrap; width: 100%;justify-content: flex-start"
        >
          <div class="search-box"><h1>代理商</h1></div>
          <div class="control-box" style="margin-top: 10px;" >
            <el-input class="control-box-input" v-model="params.name" placeholder="请输入搜索代理商名称" clearable></el-input>
            
            <el-select v-model="params.level_id" placeholder="请选择需搜索级别" clearable style="margin-left:10px;">
              <el-option
                v-for="item in levels"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
            <el-button v-if="admin_permission.indexOf('look')>-1" icon="el-icon-search" @click="getTableData" style="margin-left:10px;">搜索</el-button>
            <el-button v-if="admin_permission.indexOf('add')>-1" icon="el-icon-plus" type="primary" @click="handleOpenAdd">添加代理商</el-button>
          </div>
        </div>
        <el-tabs v-model="activeName" @tab-click="handleClick" style="margin-top:10px;">
          <el-tab-pane label="全部代理" name="all"></el-tab-pane>
          <el-tab-pane label="待审核代理" name="default"></el-tab-pane>
          <el-tab-pane label="拒绝通过" name="delete"></el-tab-pane>
        </el-tabs>
        <el-table
          :data="table"
          style="width: 100%;"
          tooltip-effect="dark"
          empty-text="暂无数据"
          class="table"
        >
          <el-table-column label="ID" prop="id" align="left" width="80"></el-table-column>
          <el-table-column label="代理商名称" prop="name" align="left" width="140px"></el-table-column>
          <el-table-column label="手机号" prop="phone" align="left" width="150px"></el-table-column>
          <el-table-column label="地址" prop="address" align="left" width="200px">
          </el-table-column>
          <el-table-column label="代理级别" prop="level_name" align="left" width="100px">
          </el-table-column>
          <el-table-column label="状态" prop="status" align="left">
            <template slot-scope="scope">
              <span v-if="(scope.row.status===0)">待审核</span>
              <el-tag v-if="(scope.row.status===1)" effect="dark" size="small">正常</el-tag>
              <el-tag v-if="(scope.row.status===2)" effect="dark" type="danger" size="small">审核拒绝</el-tag>
            </template>
          </el-table-column>

          <el-table-column label="操作" width="120" align="center" fixed="right"  v-if="admin_permission.indexOf('update')>-1 || admin_permission.indexOf('deleted')>-1 || admin_permission.indexOf('examine')>-1">
            <template slot-scope="scope">
              <div
                style="
                  width: 100%;
                  display: inline-flex;
                  justify-content: space-around;
                "
              >
                <el-link style="color: #409eff;" @click="lookDetail(scope.row.id)" v-if="admin_permission.indexOf('look')>-1">
                  <el-tooltip class="item" effect="dark" content="查看詳情" placement="top-start">
                    <i class="el-icon-view" style="font-size:16px;"></i>
                  </el-tooltip>
                </el-link>
                <el-link style="color: #409eff;" v-if="(scope.row.status !==2 || scope.row.status !==3) && admin_permission.indexOf('update')>-1" @click="editTable(scope.row.id)">
                  <el-tooltip class="item" effect="dark" content="修改" placement="top-start">
                    <i class="el-icon-edit" style="font-size:16px;"></i>
                  </el-tooltip>
                </el-link>
                <el-dropdown @command="command($event,scope.row.id)" style="">
                  <span class="el-dropdown-link" style="color: #409eff">
                    <el-tooltip class="item" effect="dark" content="更多操作" placement="top-start">
                      <i class="el-icon-arrow-down" style="font-size:16px;"></i>
                    </el-tooltip>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="appointment" v-if="(parseInt(scope.row.status) === 0)">同意代理</el-dropdown-item>
                    <el-dropdown-item command="fail" v-if="(parseInt(scope.row.status) === 0)">拒绝申请</el-dropdown-item>
                    <el-dropdown-item command="delete" v-if="admin_permission.indexOf('deleted')>-1">删除代理商</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div style="width:100%;display:flex;justify-content: flex-end;box-sizing: border-box;padding: 10px;">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="params.page"
            :hide-on-single-page="false"
            :small="true"
            :page-size="params.page_count"
            layout="total, prev, pager, next"
            :total="total">
          </el-pagination>
        </div>
      </el-main>
    </div>

      <!-- 查看详情信息 -->
    <el-dialog title="代理商详情" v-if="dialogTableVisible" :visible.sync="dialogTableVisible" width="80%">
      <agent-list :id="agentID"></agent-list>
    </el-dialog>
    <el-drawer
      title="更改代理商"
      :visible.sync="editDrawer"
      :direction="direction"
      :before-close="handleClose"
    >
      <edit-comp v-if="editDrawer" @close="handleClose" @success="handleDrawerSuccess" :id="editID" ref="newForm"></edit-comp>
    </el-drawer>

    <!-- 添加规则 -->
    <el-drawer
      title="添加代理商"
      :visible.sync="addDrawer"
      :direction="direction"
      :before-close="handleClose"
    >
      <add-comp
        @close="handleClose"
        @success="handleDrawerSuccess"
        @clear="clearContent"
        ref="newForm"
        v-if="addDrawer"
      ></add-comp>
    </el-drawer>
  </section>
</template>

<script>
  import { getList,getLevelListSelect,appointData,failData,deleteData } from "@/api/agents.js";

  import addComp from "./components/add.vue";
  import editComp from "./components/edit.vue";
  import agentList from "@/views/components/agentList.vue";
  let page_name = 'system_admin'
  export default {
    name: "App",
    components:{addComp,editComp,agentList},
    data() {
      return {
        dialogTableVisible:false,
        activeName: 'all',
        admin_permission:[],
        groupID:'',
        agentID:'',
        status: [
          {id:"",label:"全部"},
          {id:0,label:"正常"},
          {id:1,label:"禁用"},
          {id:2,label:"审核中"},
          {id:3,label:"审核拒绝"},
        ],
        options:[],
        groupList:[],
        treeCurrentNode:"",

        params: {
          page: 1,
          page_count: 10,
          name:'',
          level_id:'',
          status:'',
        },
        levels:[],

        table:[],

        service: [],
        editID: '',
        total: 0,
        outerVisible: false,
        innerVisible: false,
        addDrawer: false,
        editDrawer: false,
        direction: "rtl",
        addTradeParams: {
          name: "",
          parent_id: 0
        },
        visible: false,
        scopeForm:{
          id:'',
          sort: ''
        }
      };
    },

    methods: {
      handleClick(tab, event) {
        if(this.activeName === 'all'){
          this.params.status = 1
        }
        if(this.activeName === 'default') this.params.status = 0
        if(this.activeName === 'delete') this.params.status = 2
        this.getTableData()
      },
      getTableData() {
        getList(this.params).then(res=>{
          if(res.code === 200){
            this.table = res.data.data
            this.params.page = res.data.current_page
            this.params.page_count = res.data.per_page
            this.total = res.data.total
          }
        })
      },
      lookDetail(id){
        this.dialogTableVisible = true
        this.agentID = id
      },
      command(e,id){
        if(e === 'appointment'){
          this.$confirm('此操作将通过申请, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            appointData(id).then(res => {
              if (res.code === 200) {
                this.$message({
                  message: "已通过",
                  type: "success"
                });
              }
              this.getTableData()
            })
          }).catch(() => {
          });
        }
        if(e === 'fail'){
          this.$confirm('此操作将拒绝通过申请, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            failData(id).then(res => {
              if (res.code === 200) {
                this.$message({
                  message: "已拒绝",
                  type: "success"
                });
              }
              this.getTableData()
            })
          }).catch(() => {
          });
        }
        if(e === 'delete'){
          this.$confirm('此操作将删除代理商, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            deleteData(id).then(res => {
              if (res.code === 200) {
                this.$message({
                  message: "已删除",
                  type: "success"
                });
              }
              this.getTableData()
            })
          }).catch(() => {
          });
        }
      },

      writeScope(id){
        console.log(id)
        this.scopeForm.id = id
        let tmp = [];
        this.service.forEach((value,key)=>{
          tmp[key] = value
          if (id === value.id){
            this.scopeForm.sort = parseInt(value.sort)
            tmp[key].write_scope = true
          }
        })
        this.service = tmp;
      },

      scopeChange(){
        editData(this.scopeForm.id,{sort:this.scopeForm.sort}).then(res=>{
          if (res.code === 200){
            this.searchSet()
          }
        })
      },

      //选择TREE
      showTreeWorker(id, pid) {
          this.params.status = id;
          this.getTableData();
      },

      // 打开添加
      handleOpenAdd() {
        this.addDrawer = true;
      },
      // 关闭添加/修改
      handleClose() {
        this.$confirm("确认关闭？")
          .then((_) => {
            this.addDrawer = false;
            this.editDrawer = false;
          })
          .catch((_) => {});
      },

      editTable(id){
        this.editID = id
        this.editDrawer = true
      },
      // 添加/修改成功
      handleDrawerSuccess() {
        this.addDrawer = false;
        this.editDrawer = false;
        this.getTableData();
        this.$refs.newForm.$refs.form.resetFields();
      },
      // 清空子组件
      clearContent() {
        this.$refs.newForm.$refs.form.resetFields();
      },
      // 分页
      prevpage() {
        this.params.page -= 1;
        this.getTableData();
      },
      nextpage() {
        this.params.page += 1;
        this.getTableData();
      },
      handleCurrentChange(val) {
        this.params.page = val;
        this.getTableData();
      },
    },
    mounted() {
      this.getTableData();
      this.admin_permission = this.$store.state.permission.permissionArr[page_name]
      this.groupID = this.$store.state.user.userData.group_id
      getLevelListSelect().then(res=>{
          if(res.code === 200){
            this.levels = res.data
          }
        })
    }
  };
</script>

<style scoped lang="scss">
  @import "@/static/default";

  .container {
    width: 100%;
    min-height: 100%;
    background-color: #fff !important;
    padding: 20px 32px;
    padding-bottom:0;
    display: inline-flex;

    .table {
      margin-top: 24px !important;
    }

    .toolbar {
      background: #fff;
      width: 100%;
      padding: 16px 32px 26px 0;
    }
  }

  .control-box{
    width: 100%;
    display:flex;
    flex-wrap: wrap;
    &-input{
      width: 150px;
    }
  }
  .el-main {
    padding: 0;
  }

  .demo-table-expand {
    font-size: 0;
  }

  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }

  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
</style>
<style>
  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding: 10px 0;
    padding-right: 8px;
  }
  .el-tree-node__expand-icon.is-leaf{
    color: #c0c4cc;
  }
</style>
